// @flow
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { getIfAllMetricsAreFrozen } from '@components/custom-discounts/utils';
import { SPMLDMutationsContext } from '@streaming-projects/orgs/org-top-level/sp-custom-discounts/contexts/SPMLDMutationsContext';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridDeleteButton,
} from '@src/formik-utils/FieldArrayGrid';
import { DEFAULT_VALUE_FOR_DB_ROW_ID, IS_VBD, ROW_ID } from '@src/constants';
import { SPUserCommitDetailsContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContext';

const getIfDimensionConfigDeleteButtonShouldBeDisabled = (readOnlyMode, rowValues, formik) => {
  if (readOnlyMode) {
    return true;
  }

  // If the row is a VBD row, then, return true to disable it
  if (rowValues?.[IS_VBD]) {
    return true;
  }

  // If the row is NOT frozen, then return false to enable it
  if (!rowValues?.isRowFrozen) {
    return false;
  }

  if (!getIfAllMetricsAreFrozen(formik.values)) {
    return true;
  }

  return !formik.isValid;
};

export const CommitDimensionsConfigDeleteButtonContainer = () => {
  const commitData = useContext(SPUserCommitDetailsContext);
  const {
    metricDiscountDeleteMutation: [deleteMLDFunc],
  } = useContext(SPMLDMutationsContext);
  const { orgId, commitId } = useParams();
  const { rowValues, readOnlyMode } = useContext(FieldArrayGridConfigItemContext);
  const formik = useFormikContext();
  const payload = {
    ...rowValues,
    id: rowValues[ROW_ID] === DEFAULT_VALUE_FOR_DB_ROW_ID ? '-1' : rowValues[ROW_ID],
    commit_version: commitData?.version,
  };

  const deleteMLDFuncParams = {
    payload: payload,
    orgId: orgId,
    commitId: commitId,
    metricDiscountId: rowValues?.metric_discount_id ?? -1,
  };

  return (
    <FieldArrayGridDeleteButton
      deleteFunc={deleteMLDFunc}
      deleteFuncParams={deleteMLDFuncParams}
      disabled={getIfDimensionConfigDeleteButtonShouldBeDisabled(readOnlyMode, rowValues, formik)}
      reloadPageAfterDelete={true}
    />
  );
};
